import React, { useEffect, useState } from "react";
import dummyProfileImg from "../../../../assets/images/dummy_profile.jpeg";
import "../../CustomerPreview.scss";
import { OCCUPATION, RESIDENT_STATUS, applicantCountConstant } from "../../../../config/constant";
import { formatDate } from "../../../../utilis/common-funtions";
import { useTranslation } from "react-i18next";
const { REACT_APP_S3_BASE_URL } = process.env;

const ApplicantDetails = ({ applicantData, masterData }) => {
  const { t } = useTranslation();
  const [applicantList, setApplicantList] = useState([]);
  let maritalStatusName = "N/A";

  useEffect(() => {
    let obj = [];
    if (applicantData && applicantData?.applicant1 !== null) {
      obj.push(applicantData?.applicant1);
    }
    if (applicantData && applicantData?.applicant2 !== null) {
      obj.push(applicantData?.applicant2);
    }
    setApplicantList(obj);
  }, [applicantData]);

  const getMaritalStatus = (value) => {
    if (value !== null) {
      masterData &&
        masterData?.Marital_Status?.map((data) => {
          if (data?.value === value) {
            maritalStatusName = data?.name;
          }
        });
      return maritalStatusName;
    } else {
      return maritalStatusName;
    }
  };

  const getGenderName = (value) => {
    if (value) {
      let genderName = masterData?.GenderIdentity?.filter(
        (data) => data?.value === value
      )?.[0]?.name;
      return genderName;
    }
  };

  return (
    <>
      {applicantList &&
        applicantList?.length > 0 &&
        applicantList?.map((data, index) => {
          return (
            <div
              key={index}
              className={`applicantDetailsCard applicant${index + 1}`}
            >
              <div className="editTitleRow">
                <div className="btnApplicantTop">
                  {index + 1 === 1 ? (
                    applicantCountConstant?.numberKeys[1]
                  ) : (
                    <>
                      {index + 1}
                      <sup>
                        {applicantCountConstant?.numberKeys[index + 1]}
                      </sup>
                    </>
                  )}{" "}
                  Applicant
                </div>
              </div>

              <div className="personalInformation">
                <div className="photo">
                  {data?.personalDetails?.image?.length > 0 ? (
                    <img
                      src={`${REACT_APP_S3_BASE_URL +
                        "/" +
                        data?.personalDetails?.image?.[0]
                        }`}
                      alt="User"
                    />
                  ) : (
                    <img src={`${dummyProfileImg}`} alt="User" />
                  )}
                </div>
                <div className="informationDetails">
                  <h2 className="name">{`${data?.personalDetails?.salutation} ${data?.personalDetails?.firstName
                    }${" "}${data?.personalDetails?.lastName}`}</h2>
                  <h3 className="relationOfApplicant">{masterData?.Identity?.filter((item) => item.value === data?.personalDetails?.relation)[0]?.name || "Relation with"}: {data?.personalDetails?.relativeName}</h3>
                  <h3 className="titlePersonalHD">Personal Details</h3>
                  <div className="personalInfo width50">
                    <div className="personalInfoRow">
                      <label className="label150">{index + 1 === 1 ? "Primary Registration Phone number:" : "Contact Number:"}</label>
                      <span>
                        {typeof data?.personalDetails?.countryCode !== "undefined"
                          ? `${data?.personalDetails?.countryCode}${data?.personalDetails?.contactNumber}`
                          : "N/A"}
                      </span>
                    </div>
                    {data?.personalDetails?.alternateContactNumber &&
                      <div className="personalInfoRow">
                        <label className="label180">Alternate Contact No.:</label>
                        <span className="marginLeft30">
                          {typeof data?.personalDetails?.alternateCountryCode !== "undefined"
                            ? `${data?.personalDetails?.alternateCountryCode}${data?.personalDetails?.alternateContactNumber}`
                            : "N/A"}
                        </span>
                      </div>
                    }
                    <div className="personalInfoRow">
                      <label className="label150">Date of Birth:</label>
                      <span>{data?.personalDetails?.dob ? formatDate(data?.personalDetails?.dob) : "N/A"}</span>
                    </div>
                    <div className="personalInfoRow">
                      <label className="label150">Email ID:</label>
                      <span
                        style={{
                          display: 'flex',
                          wordBreak: 'break-word', // Break long words
                          whiteSpace: 'normal', // Allow wrapping
                          maxWidth: '100%', // Ensure it respects container width
                        }} className="wordBreakMobile">
                        {data?.personalDetails?.emailAddress || "N/A"}
                      </span>
                    </div>

                    <div className="personalInfoRow">
                      <label className="label150">Resident Status:</label>
                      <span>
                        {data?.personalDetails?.residentStatus || "N/A"}
                      </span>
                    </div>

                    {data?.personalDetails?.nriCountry && (
                      <div className="personalInfoRow">
                        <label className="label150">Country of Residence:</label>
                        <span>
                          {data?.personalDetails?.nriCountry || "N/A"}
                        </span>
                      </div>
                    )}

                    <div className="personalInfoRow">
                      <label className="label150">Marital Status:</label>
                      <span>
                        {getMaritalStatus(
                          data?.personalDetails?.maritalStatus
                        ) || "N/A"}
                      </span>
                    </div>

                    {/* {maritalStatusName === "Married" ? (
                      <div className="personalInfoRow">
                        <label className="label150">Anniversary Date:</label>
                        <span>
                          {data?.personalDetails?.anniversaryDate ? formatDate(data?.personalDetails?.anniversaryDate) : "N/A"}
                        </span>
                      </div>
                    ) : null} */}

                    <div className="personalInfoRow">
                      <label className="label150">Gender:</label>
                      <span>{getGenderName(data?.personalDetails?.gender) || "N/A"}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lineDotted"></div>
              <div className="personalInfo width50">
                {data?.contactDetails?.panNumber !== null &&
                  data?.contactDetails?.panNumber?.length > 0 ? (
                  <div className="personalInfoRow">
                    <label className="label180">PAN Number:</label>
                    <span>{data?.contactDetails?.panNumber || "N/A"}</span>
                  </div>
                ) : null}
                {data?.contactDetails?.aadhaarNumber !== null &&
                  data?.contactDetails?.aadhaarNumber?.length > 0 ? (
                  <div className="personalInfoRow">
                    <label className="label180">Aadhaar Number:</label>
                    <span>{data?.contactDetails?.aadhaarNumber || "N/A"}</span>
                  </div>
                ) : null}

                {data?.personalDetails?.residentStatus !==
                  RESIDENT_STATUS?.Indian ? (
                  <>
                    {data?.contactDetails?.passportNumber !== null &&
                      data?.contactDetails?.passportNumber?.length > 0 ? (
                      <div className="personalInfoRow">
                        <label className="label180">Passport Number:</label>
                        <span>
                          {data?.contactDetails?.passportNumber || "N/A"}
                        </span>
                      </div>
                    ) : null}
                    {data?.contactDetails?.ociNumber !== null &&
                      data?.contactDetails?.ociNumber?.length > 0 ? (
                      <div className="personalInfoRow">
                        <label className="label180">OCI Number:</label>
                        <span>{data?.contactDetails?.ociNumber || "N/A"}</span>
                      </div>
                    ) : null}
                    {data?.contactDetails?.OCIAlternateDocType !== null &&
                      data?.contactDetails?.OCIAlternateDocType?.length > 0 ? (
                      <div className="personalInfoRow">

                        <label className="label180">OCI Document Type:</label>

                        <span>{data?.contactDetails?.OCIAlternateDocType || "N/A"}</span>
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
              <div className="notes">
                Note: All uploaded documents are included in the KYC document
                section
              </div>
              <div className="lineDotted"></div>

              <h3 className="titlePersonalHD marginBottom10">
                Communication Details
              </h3>
              <div className="personalInfo Communication width50">
                {index !== 1 && (
                  <div className="personalInfoRow">
                    <label className="label180">Permanent Address:</label>
                    <span>
                      {data?.contactDetails?.permanentAddress
                        ? data?.contactDetails?.permanentAddress?.areaName?.includes(
                          data?.contactDetails?.permanentAddress?.pinCode
                        )
                          ? data?.contactDetails?.permanentAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.permanentAddress?.areaName
                          : data?.contactDetails?.permanentAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.permanentAddress?.areaName +
                          ", " +
                          data?.contactDetails?.permanentAddress?.city +
                          ", " +
                          data?.contactDetails?.permanentAddress?.state +
                          ", " +
                          data?.contactDetails?.permanentAddress?.country +
                          `${data?.contactDetails?.permanentAddress?.pinCode
                            ? ", " +
                            data?.contactDetails?.permanentAddress
                              ?.pinCode
                            : ""
                          }`
                        : "N/A"}
                    </span>
                  </div>
                )}
                <div className="personalInfoRow">
                  <label className="label180">Communication Address:</label>
                  {index === 0 ? (
                    <span>
                      {data?.contactDetails?.communicationAddress
                        ? data?.contactDetails?.communicationAddress?.areaName?.includes(
                          data?.contactDetails?.communicationAddress?.pinCode
                        )
                          ? data?.contactDetails?.communicationAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.communicationAddress?.areaName
                          : data?.contactDetails?.communicationAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.communicationAddress
                            ?.areaName +
                          ", " +
                          data?.contactDetails?.communicationAddress?.city +
                          ", " +
                          data?.contactDetails?.communicationAddress?.state +
                          ", " +
                          data?.contactDetails?.communicationAddress
                            ?.country +
                          `${data?.contactDetails?.communicationAddress
                            ?.pinCode
                            ? ", " +
                            data?.contactDetails?.communicationAddress
                              ?.pinCode
                            : ""
                          }`
                        : "N/A"}
                    </span>
                  ) : (
                    <span>
                      {data?.contactDetails?.permanentAddress
                        ? data?.contactDetails?.permanentAddress?.areaName?.includes(
                          data?.contactDetails?.permanentAddress?.pinCode
                        )
                          ? data?.contactDetails?.permanentAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.permanentAddress?.areaName
                          : data?.contactDetails?.permanentAddress
                            ?.houseNumber +
                          ", " +
                          data?.contactDetails?.permanentAddress?.areaName +
                          ", " +
                          data?.contactDetails?.permanentAddress?.city +
                          ", " +
                          data?.contactDetails?.permanentAddress?.state +
                          ", " +
                          data?.contactDetails?.permanentAddress?.country +
                          `${data?.contactDetails?.permanentAddress?.pinCode
                            ? ", " +
                            data?.contactDetails?.permanentAddress
                              ?.pinCode
                            : ""
                          }`
                        : "N/A"}
                    </span>
                  )}
                </div>
              </div>
              <div className="lineDotted"></div>
              <h3 className="titlePersonalHD marginBottom10">
                Professional Details
              </h3>
              <div className="personalInfo width50">
                {data?.professionalDetails?.occupation ? (
                  <div className="personalInfoRow">
                    <label className="label200">Occupation:</label>
                    <span style={{
                      display: 'flex',
                      wordBreak: 'break-word', // Break long words
                      whiteSpace: 'normal', // Allow wrapping
                      maxWidth: '100%', // Ensure it respects container width
                    }}>

                      {data?.professionalDetails?.occupation || "N/A"}
                    </span>
                  </div>
                ) : null}

                {data?.professionalDetails?.industry && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t("professionalDetails.fields.industry")}:
                    </label>
                    <span>
                      {data?.professionalDetails?.industry ||
                        "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.companyName && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t(
                        "professionalDetails.fields.companyName"
                      )}
                      :
                    </label>
                    <span>
                      {data?.professionalDetails?.companyName ||
                        "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.departmentDivision && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t(
                        "professionalDetails.fields.departmentDivision"
                      )}
                      :
                    </label>
                    <span>
                      {data?.professionalDetails
                        ?.departmentDivision || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.designationIfOthers && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t("professionalDetails.fields.designation")}:
                    </label>
                    <span>
                      {data?.professionalDetails
                        ?.designationIfOthers || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.branch && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t("preview.labels.branch")}:
                    </label>
                    <span>
                      {data?.professionalDetails?.branch || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.rank && (
                  <div className="personalInfoRow">
                    <label className="label200">
                      {t("preview.labels.rank")}:
                    </label>
                    <span>
                      {data?.professionalDetails?.rank || "N/A"}
                    </span>
                  </div>
                )}

                {data?.professionalDetails?.annualIncome ? (
                  <div className="personalInfoRow">
                    <label className="label200">Annual Income:</label>
                    <span>
                      {data?.professionalDetails?.annualIncome || "N/A"}
                    </span>
                  </div>
                ) : null}
              </div>

              {data?.professionalDetails?.companyAddress && (
                  <>
                    {data?.professionalDetails?.companyAddress && (
                      <div className="personalInfoRow">
                        <label className="label200">
                          {t(
                            "professionalDetails.fields.companyAddress"
                          )}
                          :
                        </label>
                        <span
                          style={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          {data.professionalDetails.companyAddress.includes(
                            data?.professionalDetails?.companyPinCode ||
                            ""
                          )
                            ? data.professionalDetails.companyAddress
                            : `${data.professionalDetails.companyAddress
                            }${data?.professionalDetails
                              ?.companyPinCode
                              ? `, ${data.professionalDetails.companyPinCode}`
                              : ""
                            }`}
                        </span>
                      </div>
                    )}
                  </>
                )}
              {data?.professionalDetails?.officeAddress && (
                  <>
                    {" "}
                    <div className="personalInfoRow">
                      <label className="label200">
                        {t("professionalDetails.fields.officeAddress")}:
                      </label>
                      <span>
                        {data?.professionalDetails?.officeAddress
                          ? data.professionalDetails.officeAddress.includes(
                            data.professionalDetails.officePinCode
                          )
                            ? data.professionalDetails.officeAddress
                            : `${data.professionalDetails.officeAddress
                            }, ${data.professionalDetails
                              .officePinCode || ""
                            }`
                          : "N/A"}
                      </span>
                    </div>
                  </>
                )}
            </div>
          );
        })}
    </>
  );
};

export default ApplicantDetails;